import { debounce } from "debounce";

export function initInScope($scope) {

    if (matchMedia('hover: none) and (pointer: coarse)').matches) {
        return;
    }

    let $cursor = $scope.find('.js-custom-cursor');

    $scope.find('.js-drag-indicator').each(function () {
        let $area = $(this);
        let $element = $area.find('.js-drag-indicator__element');
        let $ignoredAreas = $area.find('.js-drag-indicator__ignore-area, .slick-dots');
        let areaRect = $area[0].getBoundingClientRect();

        console.log('$ignoredAreas',$ignoredAreas)

        $(window).on('scroll', debounce(function () {
            areaRect = $area[0].getBoundingClientRect()
        }, 200));

        $area.on('mouseenter', () => {
            $element.addClass('is-following');
            areaRect = $area[0].getBoundingClientRect();
            $cursor.addClass('hide');
        }).on('mouseleave', () => {
            $element.removeClass('is-following');
            $cursor.removeClass('hide');
        });

        // initial
        $area.one('mousemove', () => {
            $element.addClass('is-following');
            $cursor.addClass('hide');

        });

        $ignoredAreas.on('mouseenter', () => {
            console.log('mouseenter ignore', $element)
            $element.removeClass('is-following');
            $cursor.removeClass('hide');
        }).on('mouseleave', () => {
            $element.addClass('is-following');
            $cursor.addClass('hide');
        });

        $area.on('mousemove', (evt) => {
            $element.css({
                'transform': `translate(${evt.clientX - areaRect.left}px, ${evt.clientY - areaRect.top}px)`
            })
        });

        $area.on('mousedown', () => {
            $element.addClass('is-grabbed');
        });
        $area.on('mouseup', () => {
            $element.removeClass('is-grabbed');
        });
    })
}